/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Potvrzuji, že jsem poskytl/a veškeré nezbytné informace pro správné zpracování mé žádosti`
};

const da_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg bekræfter, at jeg har givet alle nødvendige oplysninger for at behandle min henvendelse`
};

const de_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Ich bestätige, alle notwendigen Informationen für die Bearbeitung meiner Anfrage bereitgestellt zu haben`
};

const en_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `I confirm that I have provided all the necessary information for the proper processing of my request`
};

const es_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmo que he proporcionado toda la información necesaria para el correcto tratamiento de mi consulta`
};

const fr_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Je confirme avoir fourni toutes les informations nécessaires au bon traitement de ma demande`
};

const hu_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Megerősítöm, hogy minden szükséges adatot megadtam a kérelm megfelelő kezeléséhez`
};

const it_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Confermo di aver fornito tutte le informazioni necessarie per la corretta gestione della richiesta`
};

const nl_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Ik bevestig dat ik alle benodigde informatie heb verstrekt voor een goede afhandeling van mijn aanvraag`
};

const pl_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Potwierdzam, że podałem wszystkie niezbędne informacje do realizacji mojego zapytania`
};

const pt_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmo que forneci todas as informações necessárias para o correto tratamento do meu pedido`
};

const sv_contact_fields_confirmation = /** @type {(inputs: {}) => string} */ () => {
	return `Jag bekräftar att jag har lämnat all nödvändig information för att behandla min förfrågan`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_confirmation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_confirmation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_confirmation", locale)
	if (locale === "cs") return cs_contact_fields_confirmation(inputs)
	if (locale === "da") return da_contact_fields_confirmation(inputs)
	if (locale === "de") return de_contact_fields_confirmation(inputs)
	if (locale === "en") return en_contact_fields_confirmation(inputs)
	if (locale === "es") return es_contact_fields_confirmation(inputs)
	if (locale === "fr") return fr_contact_fields_confirmation(inputs)
	if (locale === "hu") return hu_contact_fields_confirmation(inputs)
	if (locale === "it") return it_contact_fields_confirmation(inputs)
	if (locale === "nl") return nl_contact_fields_confirmation(inputs)
	if (locale === "pl") return pl_contact_fields_confirmation(inputs)
	if (locale === "pt") return pt_contact_fields_confirmation(inputs)
	return sv_contact_fields_confirmation(inputs)
};
export { contact_fields_confirmation as "contact.fields.confirmation" }